export class BasicDetails{
    public Id : Number;
    public IsActive : Boolean = true;
    public Code : String;
    public Description : String;
    public ParentId : Number;
    public MasterTypeId : Number;
    public IsEU : Boolean = false;
    public IncludeInFinance : Boolean = false;
}

export class LanguageDetails{
    public Id : Number;
    public Value : String;
    public Code : String;
    public Description : String;
    public GeneralId : Number;
    public LanguageId : Number;
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/models/general.model.ts